import React, { useMemo } from "react";
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import { ACCOUNT_DETAIL_FONT_FAMILY } from "../../../../components/AccountDetailPolicy/accountDetailTypography";

/** Same brand orange as Configuration tabs. */
export const HUB_ACCENT = "#F98125";
export const HUB_BLUE = "#193A6F";
export const HUB_TEXT = "#111827";
export const HUB_MUTED = "#6b7280";
export const HUB_TRACK = "#f3f4f6";
export const HUB_BORDER = "#e5e7eb";

/**
 * Inter + Configuration accent, scoped to Remediation Hub.
 * Does not change Hub behavior — only chrome, type, and control colors.
 */
export const RemediationHubThemeProvider = ({ children }) => {
  const parentTheme = useTheme();
  const theme = useMemo(
    () =>
      createTheme(parentTheme, {
        typography: {
          fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
        },
        palette: {
          primary: {
            main: HUB_ACCENT,
            contrastText: "#ffffff",
          },
        },
        components: {
          MuiPaper: {
            styleOverrides: {
              root: {
                fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
              },
            },
          },
          MuiTypography: {
            styleOverrides: {
              root: {
                fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
              },
            },
          },
          MuiTableCell: {
            styleOverrides: {
              root: {
                fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
              },
            },
          },
          MuiInputBase: {
            styleOverrides: {
              root: {
                fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
              },
            },
          },
          MuiIconButton: {
            styleOverrides: {
              root: {
                fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
              },
            },
          },
          MuiListItemText: {
            styleOverrides: {
              root: {
                fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
              },
              primary: {
                fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
              },
              secondary: {
                fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
              },
            },
          },
          MuiButton: {
            styleOverrides: {
              root: {
                textTransform: "none",
                fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
                fontWeight: 600,
                fontSize: "0.8125rem",
                borderRadius: "8px",
                boxShadow: "none",
                "&:hover": { boxShadow: "none" },
              },
            },
          },
          MuiTab: {
            styleOverrides: {
              root: {
                textTransform: "none",
                fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
              },
            },
          },
          MuiChip: {
            styleOverrides: {
              root: {
                fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
              },
            },
          },
          MuiAlert: {
            styleOverrides: {
              root: {
                fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
              },
            },
          },
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
              },
            },
          },
          MuiStepLabel: {
            styleOverrides: {
              label: {
                fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
              },
            },
          },
        },
      }),
    [parentTheme]
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
